export const environment = "pricing-07-25"
export const datoApiKey = "109884b2ca15119c968f49ad60391e"
